import api from './BaseApi';

export const createRoute = async (data) => {
    try {
        const response = await api.post('/admin/routes', data);
        return response; 
    } catch (error) {
        console.error('Create route error:', error);
        return error;
    }
};

export const getRoutes = async (params) => {
    try {
        const response = await api.get('/admin/routes', { params });
        return response.data;
    } catch (error) {
        console.error('Get routes error:', error);
    }
};

export const updateRoute = async (id, type, payload) => {
    try {
        const response = await api.put(`/admin/routes/${id}?type=${type}`, payload);
        return response;
    } catch (error) {
        console.error('Update route error:', error);
        return error;
    }
};

export const deleteRoute = async (id, type) => {
    try {
        const response = await api.delete(`/admin/routes/${id}?type=${type}`);
        return response.data;
    } catch (error) {
        console.error('Delete route error:', error);
        return error;
    }
};

export const updateRouteStatus = async (id, payload) => {
    try {
        const response = await api.patch(`/admin/routes/${id}/status`, payload);
        return response;
    } catch (error) {
        console.error('Update route status error:', error);
        throw error;
    }
};

export const syncFlightsData = async (payload) => {
    try {
        const response = await api.post('/admin/flights/sync', payload);
        return response; 
    } catch (error) {
        console.error('Sync flights data error:', error);
        return error;
    }
};